import React, { useState, useRef } from "react";
import { Card, Carousel, Typography } from "antd";
import MediaFetcher from "../library/MediaFetcher";
import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";

const PrevArrow = props => {
  const { className, style, onClick } = props;
  return (
    <LeftCircleFilled
      className={className}
      style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
      onClick={onClick}
    />
  );
};

const NextArrow = props => {
  const { className, style, onClick } = props;
  return (
    <RightCircleFilled
      className={className}
      style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
      onClick={onClick}
    />
  );
};

const AdPreviewCard = ({ mediaKeys }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const mediaRefs = useRef([]);

  const handleBeforeChange = (from, to) => {
    // Pause the video if the current slide contains a video
    if (mediaRefs.current[from] && mediaRefs.current[from].pause) {
      mediaRefs.current[from].pause();
    }
    setCurrentSlide(to);
  };

  return (
    <Card
      title={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography.Text strong>AD PREVIEW</Typography.Text>
          <Typography.Text style={{ fontSize: "12px", color: "gray" }}>
            Ad Unit {currentSlide + 1} of {mediaKeys.length}
          </Typography.Text>
        </div>
      }
      className="ccard-image"
    >
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Carousel
          arrows
          prevArrow={<PrevArrow />}
          nextArrow={<NextArrow />}
          beforeChange={handleBeforeChange}
          className="custom-carousel-dots"
        >
          {mediaKeys.map((key, index) => (
            <div key={index}>
              <MediaFetcher
                ref={el => (mediaRefs.current[index] = el)}
                mediaKey={key}
                width="100%"
                height="280px"
                maxheight="100%"
                objectFit="contain"
              />
            </div>
          ))}
        </Carousel>
      </div>
    </Card>
  );
};

export default AdPreviewCard;
